export const messages = {
  en: {
    accountWithdrawalApplyFkManage: {
      title: 'Withdrawal Payment',
      amount: 'Withdrawal Amount',
      applyUserName: 'Applicant Name',
      applyUserTel: 'Applicant Phone',
      context: 'Application Note',
      stateName: 'Status',
      operation: 'Operation',
      pay: 'Payment'
    },
    accountPay: {
      title: 'Bank Information',
      bankInfo: 'Bank Information',
      paymentInfo: 'Payment Information',
      personName: 'Cardholder',
      bankName: 'Bank Name',
      bankCode: 'Account Number',
      paymentStatus: 'Payment Status',
      selectStatus: 'Select Payment Status',
      approvePayment: 'Approve Payment',
      rejectPayment: 'Reject Payment',
      reason: 'Reason',
      reasonPlaceholder: 'Required, please fill in the reason',
      approve: 'Approve',
      reject: 'Reject',
      statusRequired: 'Payment status cannot be empty',
      reasonRequired: 'Reason content cannot be empty',
      reasonMaxLength: 'Reason content cannot exceed 200 characters'
    }
  },
  zh: {
    accountWithdrawalApplyFkManage: {
      title: '提现付款',
      amount: '提现金额',
      applyUserName: '申请人名称',
      applyUserTel: '申请人电话',
      context: '申请说明',
      stateName: '状态',
      operation: '操作',
      pay: '付款'
    },
    accountPay: {
      title: '银行信息',
      bankInfo: '银行信息',
      paymentInfo: '付款信息',
      personName: '持卡人',
      bankName: '开户行',
      bankCode: '账号',
      paymentStatus: '付款状态',
      selectStatus: '选择付款状态',
      approvePayment: '同意付款',
      rejectPayment: '拒绝付款',
      reason: '原因',
      reasonPlaceholder: '必填，请填写原因',
      approve: '同意',
      reject: '拒绝',
      statusRequired: '审核状态不能为空',
      reasonRequired: '原因内容不能为空',
      reasonMaxLength: '原因内容不能超过200字符'
    }
  }
}